<script setup>
import { ref } from 'vue';
import { Icon } from '@iconify/vue';

const year = new Date().getUTCFullYear();

const quickLinks = ref([
  { textKey: 'nav.links[0].text', to: '/' },
  { textKey: 'nav.links[3].text', to: '/services' },
  { textKey: 'nav.links[2].text', to: '/expertise' },
  { textKey: 'nav.links[1].text', to: '/training' },
  { textKey: 'nav.links[4].text', to: '/ourBenefits' },
]);

const companyLinks = ref([
  { textKey: 'nav.links[7].text', to: '/companyPolicies' },
  { textKey: 'nav.links[6].text', to: '/partner' },
  { textKey: 'nav.links[5].text', to: '/contact' },
]);

const contactInfo = ref([
  { icon: 'solar:phone-outline', text: '+237 674-646-019', href: 'tel:+237674646019' },
  { icon: 'solar:letter-outline', text: 'hozalogisticsconsultants@gmail.com', href: 'mailto:hozalogisticsconsultants@gmail.com' },
  { icon: 'solar:map-point-outline', text: 'Douala, Cameroon', href: '#' },
]);

const socialLinks = ref([
    { icon: 'mdi:linkedin', href: 'https://www.linkedin.com/in/ste-hoza-logistique-conseil-1087a0322', name: 'LinkedIn' },
    { icon: 'mdi:whatsapp', href: 'https://wa.me/658156519', name: 'WhatsApp' },
]);
</script>

<template>
  <footer class="footer-container" data-aos="fade-up">
    <div class="footer-main">
      <div class="footer-grid">
        <!-- Column 1: Brand & Newsletter -->
        <div class="footer-column">
          <router-link to="/" class="footer-logo">
            <img src="@/assets/new_logo_hlc.png" alt="HLC Logo">
          </router-link>
          <p class="footer-tagline">{{ $t( 'Your expert partner in logistics and transport solutions.') }}</p>
          <!-- <h4 class="footer-title">{{ $t( 'Stay Updated') }}</h4>
          <form class="newsletter-form">
            <input type="email" :placeholder="$t('footer.newsletter.placeholder', 'Enter your email')">
            <button type="submit" :aria-label="$t('footer.newsletter.submit', 'Subscribe')">
              <Icon icon="solar:arrow-right-linear" />
            </button>
          </form> -->
        </div>

        <!-- Column 2: Quick Links -->
        <div class="footer-column">
          <h4 class="footer-title">{{ $t('footer.useful_links.title') }}</h4>
          <ul class="footer-links">
            <li v-for="link in quickLinks" :key="link.to">
              <router-link :to="link.to">{{ $t(link.textKey) }}</router-link>
            </li>
          </ul>
        </div>

        <!-- Column 3: Company Links -->
        <div class="footer-column">
          <h4 class="footer-title">{{ $t('footer.company_links.title', 'Company') }}</h4>
          <ul class="footer-links">
            <li v-for="link in companyLinks" :key="link.to">
              <router-link :to="link.to">{{ $t(link.textKey) }}</router-link>
            </li>
          </ul>
        </div>

        <!-- Column 4: Contact Info -->
        <div class="footer-column">
          <h4 class="footer-title">{{ $t('footer.important.contact_info.title') }}</h4>
          <ul class="footer-contact">
            <li v-for="item in contactInfo" :key="item.icon">
              <a :href="item.href">
                <Icon :icon="item.icon" />
                <span>{{ item.text }}</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <p class="copyright">&#169; {{ year }} Hoza Logistics Consultancy. {{ $t('footer.copyright', 'All rights reserved.') }}</p>
      <div class="footer-socials">
        <a v-for="social in socialLinks" :key="social.name" :href="social.href" target="_blank" :aria-label="social.name">
          <Icon :icon="social.icon" />
        </a>
      </div>
    </div>
  </footer>
</template>

<style scoped>
.footer-container {
  background-color: #141d38;
  color: #a9b3c9;
  font-family: 'Poppins', sans-serif;
}
.footer-main {
  padding: 5rem 5% 3rem;
}
.footer-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 3rem;
  max-width: 1200px;
  margin: 0 auto;
}
.footer-column {
  display: flex;
  flex-direction: column;
}
.footer-logo {
  display: block;
  width: 60px;
  margin-bottom: 1rem;
}
.footer-logo img {
  width: 100%;
  height: auto;
}
.footer-tagline {
  font-size: 0.9rem;
  line-height: 1.6;
  margin-bottom: 2rem;
}
.footer-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #fff;
  margin: 0 0 1.5rem 0;
  text-transform: uppercase;
}
.newsletter-form {
  position: relative;
  display: flex;
}
.newsletter-form input {
  width: 100%;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 6px;
  padding: 12px 45px 12px 15px;
  color: #fff;
  outline: none;
}
.newsletter-form input::placeholder {
  color: #a9b3c9;
}
.newsletter-form button {
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
  background: #fcbc0d;
  color: #141d38;
  border: none;
  width: 34px;
  height: 34px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.2rem;
}
.footer-links {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.footer-links a {
  color: #a9b3c9;
  text-decoration: none;
  transition: color 0.3s ease, padding-left 0.3s ease;
  position: relative;
}
.footer-links a:hover {
  color: #fff;
  padding-left: 5px;
}
.footer-contact {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1.2rem;
}
.footer-contact a {
  display: flex;
  align-items: center;
  gap: 0.8rem;
  color: #a9b3c9;
  text-decoration: none;
  transition: color 0.3s ease;
}
.footer-contact a:hover {
  color: #fff;
}
.footer-contact .iconify {
  font-size: 1.2rem;
}
.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  padding: 1.5rem 5%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;
  max-width: 1200px;
  margin: 0 auto;
}
.copyright {
  font-size: 0.85rem;
}
.footer-socials {
  display: flex;
  gap: 1rem;
}
.footer-socials a {
  color: #a9b3c9;
  font-size: 1.3rem;
  transition: color 0.3s ease, transform 0.3s ease;
}
.footer-socials a:hover {
  color: #fff;
  transform: translateY(-2px);
}
@media (max-width: 768px) {
  .footer-grid {
    grid-template-columns: 1fr;
  }
  .footer-bottom {
    flex-direction: column;
    text-align: center;
  }
}
</style>
